import { IntlErrorCode } from "@formatjs/intl";
import React, { useCallback } from "react";
import { i18nRoot } from "./i18nRoot";
import { createI18nProvider } from "./integrations/formatjs/I18nContext";
import { missingTranslationFingerprint } from "./integrations/formatjs/missingTranslationFingerprint";
const i18n = ({ fetchTranslation, read, write, domain }) => {
    const I18nRoot = i18nRoot({ fetchTranslation, read, write, domain });
    const I18nProvider = createI18nProvider({ domain });
    // eslint-disable-next-line react/prop-types
    const I18n = ({ locale, children, loader, onError, includeDevTools, }) => {
        // eslint-disable-next-line react/prop-types
        const I18nRootChildren = ({ locale, translation, isTranslationReady, }) => {
            const handleI18nError = useCallback((error) => {
                if (error.code === IntlErrorCode.MISSING_TRANSLATION) {
                    if (!isTranslationReady(locale)) {
                        return;
                    }
                    onError?.(error, missingTranslationFingerprint({ error, locale }));
                    return;
                }
                onError?.(error);
            }, 
            // oxlint misreads `onError` as an outer-scope value because `I18nRootChildren` is
            // invoked as a plain callback, not via JSX. Dropping it would pin `handleI18nError`
            // to the `onError` captured on the first call.
            // eslint-disable-next-line react-hooks/exhaustive-deps
            [isTranslationReady, locale, onError]);
            return translation ? (React.createElement(I18nProvider, { key: locale, locale: locale, 
                // eslint-disable-next-line react/prop-types
                messages: translation.messages, onError: handleI18nError }, children)) : (loader);
        };
        return (React.createElement(I18nRoot, { includeDevTools: includeDevTools, locale: locale }, I18nRootChildren));
    };
    return I18n;
};
export { i18n };
